module.exports = __webpack_public_path__ + "img/ys-bg-4.074c82fb.png";